<template>
  <span :for="id" class="btn-radio"
        @click="sendClickEvent($event)"
        @mousedown="sendMousedownEvent($event)"
        @mouseover="sendMouseoverEvent($event)"
        @mouseout="sendMouseoutEvent($event)"
  >
    <input type="radio"
           class="radiobtn"
           :name="name"
           :id="id"
           :value='value'
           :checked="checked === value"
           :tabindex="tabindex"
           :disabled="disabled"
           @change="updateValue($event) + onChange($event)"
           @focus="onFocus($event)"
           @blur="onBlur($event)"
           @input="sendInputEvent($event)"
           @keydown="sendKeydownEvent($event)"
           @keyup="sendKeyupEvent($event)"
    >
    <label v-if="label" v-html="label" :for="id" :class="[variant]"></label>
    <label v-else :for="id" :class="[variant]"><slot></slot></label>
  </span>
</template>

<script>
import FormEvent from '../../components/mixin/FormEvent'

export default {
  name: 'btn-radio',
  mixins: [FormEvent],
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    variant: { type: String },
    size: { type: String },
    name: { type: String },
    label: { type: String },
    id: { type: String },
    tabindex: { type: String },
    disabled: { type: String },
    reff: { type: String },
    checked: {},
    value: {},
    trackingName: { type: String },
    onChange: {
      type: Function,
      default: function () {}
    }
  },
  methods: {
    updateValue (e) {
      e.preventDefault()
      this.sendChangeEvent(e)
      this.$emit('input', this.value)
      this.$emit('checked', this.value)
    },
    onFocus (e) {
      this.sendFocusEvent(e)
      this.$emit('focus', e)
    },
    onBlur (e) {
      this.sendBlurEvent(e)
      this.$emit('blur', e)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.btn-radio {
  text-align: left;
  display: inline-block;
  width: calc(50% - 5px);
  @include mq-up(md) {
    width: 161px;
  }
  // ラジオボタン
  >.radiobtn{
    display: none;
  }
  >.radiobtn + label{
    @include flex(flex,flex-start,center,row,nowrap);
    padding-left: 30px;
    position:relative;
    margin-right: 20px;
    border: 1px solid $secondary;
    border-radius: 10px;
    background-color: $white;
    height: 55px;
    width: 100%;
    cursor: pointer;
    @include mq-up(md) {
      height: 62px;
      padding-right: 1em;
    }
  }
  >.radiobtn + label::before{
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 8px);
    left: 10px;
    width: 15px;
    height: 15px;
    border: 1px solid $primary;
    border-radius: 50%;
    @include mq-up(md) {
      top: calc(50% - 7px);
    }
  }
  >.radiobtn:checked + label{
    border: 1px solid $primary;
  }
  >.radiobtn:checked + label::after{
    content: "";
    display: block;
    position: absolute;
    top: calc(50% - 5px);
    left: 13px;
    width: 9px;
    height: 9px;
    background: $primary;
    border-radius: 50%;
    @include mq-up(md) {
      top: calc(50% - 4px);
    }
  }
}
.btn-radio {
  &._font-sm {
    >.radiobtn + label {
      font-size: 14px;
    }
  }
  &.disabled {
    pointer-events: none;
    >.radiobtn + label {
      background-color: #f5f5f5;
      color: #aaaaaa;
    }
    >.radiobtn + label::before{
      border: 1px solid #aaaaaa;
    }
  }
}

@include mq-down(xs) {
  .btn-radio {
    .-xs {
      font-size: 12px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/button/BtnRadio.vue